export const limit = (str = '') => {
  return str.length > 10 ? str.substr(0, 10) + '...' : str;
};

const formatCompany = (company_name = ''): string => {
  return limit(company_name);
};

export default formatCompany;
